import { atom } from "jotai";

import { EnterPasswordStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToPasswordStep = atom(
  null,
  (get, set, { verifiedEmail }: { verifiedEmail: string }) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: EnterPasswordStep = {
      step: "EnterPassword",
      verifiedEmail,
      backStep: "Initial",
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.EnterPasswordStep", nextStep);
  }
);
